import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export const CallButton = () => {
  return (
    <motion.a
      data-testid="call-nagel-floating-button"
      href="tel:+12095451696"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, type: "spring", stiffness: 260, damping: 20 }}
      className="group fixed bottom-20 right-4 sm:bottom-6 sm:right-6 z-50 h-12 flex items-center rounded-full overflow-hidden shadow-[0_10px_36px_rgba(240,90,36,0.4)] hover:shadow-[0_14px_44px_rgba(240,90,36,0.55)] transition-shadow duration-300"
      aria-label="Call Nagel at (209) 545-1696"
    >
      <span className="texture-grain absolute inset-0 transition-transform duration-500 group-hover:scale-110" />
      <span className="relative z-10 max-w-0 group-hover:max-w-[240px] transition-[max-width,padding] duration-500 overflow-hidden whitespace-nowrap text-white text-xs font-bold tracking-[0.1em] group-hover:pl-5">
        CALL NAGEL&nbsp;&nbsp;(209) 545-1696
      </span>
      <span className="relative z-10 w-12 h-12 shrink-0 flex items-center justify-center text-white">
        <Phone className="w-5 h-5 transition-transform duration-500 group-hover:rotate-12" />
      </span>
    </motion.a>
  );
};
